export const EPST_ADULTS_DISTRIBUTIONS = {
    1: {  // Grammar
        1: { questions: 4, time: 60 },
        2: { questions: 5, time: 60 },
        3: { questions: 5, time: 60 },
        4: { questions: 6, time: 60 },
        5: { questions: 6, time: 60 },
        6: { questions: 7, time: 60 },
        7: { questions: 7, time: 60 },
    },
    2: {  // Reading (tiempo en segundos)
		1: { questions: 0, time: 0 },  // PreA1
        2: { questions: 0, time: 0 },  // A1
        3: { questions: 3, time: 240 },  // 4 min
        4: { questions: 4, time: 360 },  // 6 min
        5: { questions: 4, time: 360 },
        6: { questions: 5, time: 480 },  // 8 min
        7: { questions: 5, time: 480 },
    },
	3: {  // Listening
        1: { questions: 0, time: 0 },  // PreA1
        2: { questions: 0, time: 0 },  // A1
        3: { questions: 3, time: 240 },  // 3 min + 1 extra
        4: { questions: 4, time: 360 },  // 4 + 2
        5: { questions: 4, time: 360 },  // 4 + 2
        6: { questions: 5, time: 480 },  // 5 + 3
        7: { questions: 5, time: 480 }   // 5 + 3
    },
	4: {  // Writing
        1: { questions: 0, time: 0 },     // PreA1
        2: { questions: 0, time: 0 },     // A1
        3: { questions: 1, time: 120 },   // A2 -> 2 min
        4: { questions: 0, time: 0 },     // B1
        5: { questions: 1, time: 180 },   // B2 -> 3 min
        6: { questions: 0, time: 0 },     // C1
        7: { questions: 1, time: 240 }    // C2 -> 4 min
    },
	5: {  // Speaking
        1: { questions: 0, time: 0 },      // PreA1
        2: { questions: 1, time: 120 },    // A1 -> 2 min
        3: { questions: 0, time: 0 },      // A2
        4: { questions: 1, time: 240 },    // B1 -> 4 min
        5: { questions: 0, time: 0 },      // B2
        6: { questions: 1, time: 300 },    // C1 -> 5 min
        7: { questions: 0, time: 0 }       // C2
    }
};

export const EPST_KIDS_DISTRIBUTIONS = {
    1: {  // Grammar
        1: { questions: 4, time: 60 },
        2: { questions: 4, time: 60 },
        3: { questions: 4, time: 60 },
        4: { questions: 4, time: 60 },
        5: { questions: 4, time: 60 },
        6: { questions: 5, time: 60 },
        7: { questions: 5, time: 60 },
    },
    2: {  // Reading (tiempo en segundos)
		1: { questions: 0, time: 0 },  // PreA1
        2: { questions: 3, time: 120 },  // A1
        3: { questions: 3, time: 300 },  // 4 min
        4: { questions: 0, time: 0 },  // 6 min
        5: { questions: 3, time: 300 },
        6: { questions: 0, time: 0 },  // 8 min
        7: { questions: 3, time: 360 },
    },
	3: {  // Listening
        1: { questions: 0, time: 0 },  // PreA1
        2: { questions: 3, time: 120 },  // A1
        3: { questions: 3, time: 240 },  // 3 min + 1 extra
        4: { questions: 0, time: 0 },  // 4 + 2
        5: { questions: 3, time: 300 },  // 4 + 2
        6: { questions: 0, time: 0 },  // 5 + 3
        7: { questions: 3, time: 460 }   // 5 + 3
    },
	4: {  // Writing
        1: { questions: 0, time: 0 },     // PreA1
        2: { questions: 0, time: 0 },     // A1
        3: { questions: 1, time: 120 },   // A2 -> 2 min
        4: { questions: 0, time: 0 },     // B1
        5: { questions: 1, time: 120 },   // B2 -> 3 min
        6: { questions: 0, time: 0 },     // C1
        7: { questions: 1, time: 120 }    // C2 -> 4 min
    },
	5: {  // Speaking
        1: { questions: 0, time: 0 },      // PreA1
        2: { questions: 1, time: 180 },    // A1 -> 2 min
        3: { questions: 0, time: 0 },      // A2
        4: { questions: 1, time: 300 },    // B1 -> 4 min
        5: { questions: 0, time: 0 },      // B2
        6: { questions: 1, time: 360 },    // C1 -> 5 min
        7: { questions: 0, time: 0 }       // C2
    }
};
